export default function Machines_D_7 (number = 1) {
  return {
    name: '矩阵研究站',
    icon: '/static/img/machines/d7.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_7.js